import { AdminTribeReportPDF } from './AdminTribeReportPDF';

export default AdminTribeReportPDF;